import React from "react";

type Props = {
  className?: string;
  size?: number;
  color?: string;
};

const DeleteIcon = ({ className = "", size = 16, color = "#1F2937" }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M2 4H14" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.6663 4V13.3333C12.6663 14 11.9997 14.6667 11.333 14.6667H4.66634C3.99967 14.6667 3.33301 14 3.33301 13.3333V4"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33301 3.9987V2.66536C5.33301 1.9987 5.99967 1.33203 6.66634 1.33203H9.33301C9.99967 1.33203 10.6663 1.9987 10.6663 2.66536V3.9987"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 7.33203V11.332"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 7.33203V11.332"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
